import Actions from './component';

export default Actions;
